/* QUANTICA · Videos en loop de las tarjetas.

   Unica responsabilidad: respetar "reducir movimiento". Un clip que se
   repite solo es exactamente el tipo de animacion que esa preferencia pide
   frenar, y el atributo autoplay del HTML no la mira.

   Al pausarlo en el cuadro 0 queda visible el poster, que es la imagen de la
   tarjeta: la persona ve la foto en vez de un rectangulo negro. */

(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!reduce) return;

  function aplicar() {
    if (!reduce.matches) return;
    document.querySelectorAll('video[data-loop-video]').forEach(function (v) {
      v.autoplay = false;
      v.loop = false;
      try { v.pause(); v.currentTime = 0; } catch (e) {}
    });
  }

  aplicar();
  if (reduce.addEventListener) reduce.addEventListener('change', aplicar);
  document.addEventListener('shopify:section:load', aplicar);
})();
